import { LoginPage as KitLoginPage } from 'auth-sso-kit/client';

export function LoginPage() {
  return (
    <KitLoginPage
      title="Ressources"
      subtitle="Capacité & utilisation des espaces — L'Éveil"
      emailPlaceholder="prenom.nom@aeveil.ch"
    />
  );
}
